// This file contains stimulation activities categorized by age range.
// In a real app, this can be expanded significantly.

export const stimulationActivities = [
    {
        ageRange: [0, 3], // 0-3 months
        title: "Stimulasi untuk Bayi 0-3 Bulan",
        activities: [
            { id: "s03_1", text: "Mengajak bayi tersenyum dan berbicara." },
            { id: "s03_2", text: "Menggantung benda berwarna cerah yang bergerak." },
            { id: "s03_3", text: "Memperdengarkan musik lembut kepada bayi." },
            { id: "s03_4", text: "Meraih dan memegang mainan." },
        ]
    },
    {
        ageRange: [4, 6], // 4-6 months
        title: "Stimulasi untuk Bayi 4-6 Bulan",
        activities: [
            { id: "s46_1", text: "Bermain 'Cilukba'." },
            { id: "s46_2", text: "Membantu bayi untuk tengkurap dan telentang." },
            { id: "s46_3", text: "Memperlihatkan cermin kepada bayi." },
            { id: "s46_4", text: "Mengajak bayi meraih benda sedikit lebih jauh." },
        ]
    },
    {
        ageRange: [7, 12], // 7-12 months
        title: "Stimulasi untuk Bayi 7-12 Bulan",
        activities: [
            { id: "s712_1", text: "Mengajarkan bayi duduk." },
            { id: "s712_2", text: "Mengajak memanggil 'mama' atau 'papa'." },
            { id: "s712_3", text: "Melatih bayi berdiri berpegangan." },
            { id: "s712_4", text: "Memberikan mainan yang bisa dipukul." },
        ]
    },
    {
        ageRange: [13, 24], // 13-24 months
        title: "Stimulasi untuk Anak 1-2 Tahun",
        activities: [
            { id: "s1324_1", text: "Melatih berjalan tanpa bantuan." },
            { id: "s1324_2", text: "Mengajak anak mencoret-coret dengan krayon." },
            { id: "s1324_3", text: "Menyusun menara dari 2-3 balok." },
            { id: "s1324_4", text: "Mengajarkan nama bagian tubuh." },
        ]
    },
    {
        ageRange: [25, 36], // 25-36 months
        title: "Stimulasi untuk Anak 2-3 Tahun",
        activities: [
            { id: "s2536_1", text: "Membacakan buku cerita bergambar." },
            { id: "s2536_2", text: "Melatih kemandirian seperti memakai baju sendiri." },
            { id: "s2536_3", text: "Bermain tebak nama benda dan fungsinya." },
            { id: "s2536_4", text: "Mengajak bermain peran sederhana (contoh: dokter-dokteran)." },
        ]
    },
    {
        ageRange: [37, 48], // 37-48 months
        title: "Stimulasi untuk Anak 3-4 Tahun",
        activities: [
            { id: "s3748_1", text: "Mengajarkan konsep berhitung ringan 1 sampai 10." },
            { id: "s3748_2", text: "Melatih anak menggosok gigi tanpa dibantu." },
            { id: "s3748_3", text: "Bermain melompat dengan dua kaki dan berlari rintangan." },
            { id: "s3748_4", text: "Minta anak menceritakan kembali kegiatannya hari ini." },
        ]
    },
    {
        ageRange: [49, 60], // 49-60 months
        title: "Stimulasi untuk Anak 4-5 Tahun",
        activities: [
            { id: "s4960_1", text: "Mengajarkan anak menggambar tanda silang, lingkaran, dan bentuk sederhana." },
            { id: "s4960_2", text: "Bermain dengan warna-warna dan minta menyebutkannya." },
            { id: "s4960_3", text: "Membiasakan anak menceritakan alasan atau perasaannya (Mengapa?)." },
            { id: "s4960_4", text: "Berlatih berdiri menggunakan satu kaki untuk keseimbangan." },
        ]
    },
    {
        ageRange: [61, 72], // 61-72 months
        title: "Stimulasi untuk Anak 5-6 Tahun",
        activities: [
            { id: "s6172_1", text: "Mengajak anak mengenal dan menulis huruf alphabet." },
            { id: "s6172_2", text: "Mengasah logika dengan lawan kata (contoh: panas-dingin, besar-kecil)." },
            { id: "s6172_3", text: "Melatih anak menangkap bola dengan baik menggunakan dua tangan." },
            { id: "s6172_4", text: "Mengajak anak bermain kelompok untuk melatih kepatuhan pada aturan main." },
        ]
    }
];
